import "./style/main.styl"
import { TweenMax, Power2, TimelineMax, TimelineLite, TweenLite } from "gsap/TweenMax"
import $ from "jquery"

//---------------nav hight resize and show navbar after 100vh
// const $nav = $("nav")
// const $win = $(window)
// const winH = $win.height()
// $win.on("scroll", function () {
//     $nav.toggleClass("show", $(this).scrollTop() > winH / 10)
// }).on("resize", function () {
//     winH = $(this).height()
// })
$(window).on('scroll', function () {
    if ($(window).scrollTop()) {
        $('nav').addClass('show')
    } else {
        $('nav').removeClass('show')
    }
})
//---------------navbar slide show animation
const navSlide = () => {
    const hamburger = document.querySelector(".hamburger")
    const nav = document.querySelector(".nav-link")
    const navLinks = document.querySelectorAll(".nav-link li")

    hamburger.addEventListener("click", () => {
        nav.classList.toggle("nav-active")
        navLinks.forEach((link, index) => {
            if (link.style.animation) {
                link.style.animation = ""
            } else {
                link.style.animation = `navLinkFade 0.5s ease forwards ${index / 7 + 0.2}s`
            }
        })
        hamburger.classList.toggle("toggle")
    })

}
navSlide()
//-------------------------------scroll down smooth
$(document).on('click', 'a[href^="#"]', function (e) {
    e.preventDefault();
    $('html, body').stop().animate({
        scrollTop: $($(this).attr('href')).offset().top - $("nav").height()

    }, 400, 'swing');
});
//-------------------------------slide move
const $activeSlide = $(".active")
const $homeSlide = $(".slide")
const $slideNavPrev = $("#prev")
const $slideNavNext = $("#next")
const cardContent = ".cardContent"
const cardImg = "[class^=cardImg]"
function init() {
    TweenMax.set($homeSlide.not($activeSlide), { autoAlpha: 0 })
    TweenMax.set($slideNavPrev, { autoAlpha: 0.2 })

}
init()
const goToNextSlide = (slideOut, slideIn, slideInAll) => {
    const tLine = new TimelineLite()
    const slideOutContent = slideOut.find(cardContent)
    const slideInContent = slideIn.find(cardContent)
    const slideOutImg = slideOut.find(cardImg)
    const slideInImg = slideIn.find(cardImg)
    const index = slideIn.index()
    const cardLen = $homeSlide.length
    if (slideIn.length !== 0) {
        tLine
            .set(slideIn, { autoAlpha: 1, className: '+=active' })
            .set(slideOut, { className: '-=active' })
            .to(slideOutContent, 0.65, { y: "+=40vmin", ease: Power3.easeInOut }, 0)
            .to(slideOutImg, 0.65, { backgroundPosition: "bottom", ease: Power3.easeInOut }, 0)
            .to(slideInAll, 1, { y: "-=100%", ease: Power3.easeInOut }, 0)
            .fromTo(slideInContent, 0.65, { y: "-=5vmin" }, { y: 0, ease: Power3.easeInOut }, "-=0.7")
            .fromTo(slideInImg, 0.65, { backgroundPosition: "top" }, { backgroundPosition: "bottom", ease: Power3.easeInOut }, "-=0.7")
        TweenMax.set($slideNavPrev, { autoAlpha: 1 })
    }
    if (index === cardLen - 1) {
        TweenMax.to($slideNavNext, 0.3, { autoAlpha: 0.2, ease: Linear.easeNone })
    }
}
$slideNavNext.click((e) => {
    e.preventDefault()
    const slideOut = $(".slide.active")
    const slideIn = $(".slide.active").next(".slide")
    const slideInAll = $(".slide")
    goToNextSlide(slideOut, slideIn, slideInAll)
})
const goToPreviousSlide = (slideOut, slideIn, slideInAll) => {
    const tLine = new TimelineLite()
    const slideOutContent = slideOut.find(cardContent)
    const slideInContent = slideIn.find(cardContent)
    const slideOutImg = slideOut.find(cardImg)
    const slideInImg = slideIn.find(cardImg)
    const index = slideIn.index()
    const cardLen = $homeSlide.length
    if (slideIn.length !== 0) {
        tLine
            .set(slideIn, { autoAlpha: 1, className: "+=active" })
            .set(slideOut, { className: "-=active" })
            .to(slideInContent, 0.65, { y: '-=40vmin', ease: Power3.easeInOut }, 0)
            .to(slideInImg, 0.65, { backgroundPosition: "top", ease: Power3.easeInOut }, 0)
            .to(slideInAll, 1, { y: "+=100%", ease: Power3.easeInOut }, 0)
            .fromTo(slideOutContent, 0.65, { y: "-=5vmin" }, { y: 0, ease: Power3.easeInOut }, "-=0.2")
            .fromTo(slideOutImg, 0.65, { backgroundPosition: "bottom" }, { backgroundPosition: "top", ease: Power3.easeInOut }, "-=0.7")
    }
    TweenMax.set($slideNavNext, { autoAlpha: 1 })
    if (index === 0) {
        TweenMax.to($slideNavPrev, 0.3, { autoAlpha: 0.2, ease: Linear.easeNone })
    }
}
$slideNavPrev.click((e) => {
    e.preventDefault()
    const slideOut = $(".slide.active")
    const slideIn = $(".slide.active").prev(".slide")
    const slideInAll = $(".slide")
    goToPreviousSlide(slideOut, slideIn, slideInAll)
})

//-------------------------------home animate
const HomeRight = document.querySelector("section#home .right")
const HomeH3 = document.querySelectorAll("section#home .main")


const tl = new TimelineMax()
tl.fromTo(HomeRight, 1.2, { x: "-100%" }, { x: "0%", ease: Power2.easeInOut })
    .fromTo(HomeH3, 1.2, { opacity: 0, x: 30 }, { opacity: 1, x: 0 }, "-=0.5")